
import { Component, Watch } from 'vue-property-decorator';
import VOpeningHourBundle from '@/components/shared/domain/VOpeningHoursBundle.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { OpeningHour } from '@/interfaces/models/OpeningHour';

@Component({
  components: { VOpeningHourBundle },
})
export default class AvailableHourForm extends mixins(StackedForm) {
  public $refs!: {
    availableHours: InstanceType<typeof VOpeningHourBundle> & {
      validate: () => Promise<boolean>;
      hours: OpeningHour[];
      getHours: () => OpeningHour[];
      setHours: (hours: OpeningHour[], overwrite?: boolean) => void;
    };
  };

  public async validate(): Promise<boolean> {
    return this.$refs.availableHours?.validate();
  }

  public getData() {
    return {
      availableHours: this.$refs.availableHours.getHours(),
    };
  }

  public setData(data: OpeningHour[]) {
    this.$refs.availableHours.setHours(data, true);
  }

  public mounted(): void {
    if (this.initialValues) {
      // @ts-ignore
      this.$refs.availableHours.setHours(this.initialValues.availableHours ?? []);
    }
  }

  @Watch('initialValues', { deep: true })
  public setDefaultData(data: OpeningHour[]) {
    if (this.initialValues) {
      // @ts-ignore
      this.$refs.availableHours.setHours(this.initialValues.availableHours ?? [], true);
    }
  }
}
